// @flow
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string,
  description: string,
  onClose: (boolean) => void,
  open: boolean,
};

const ConfirmationDialog = (props: Props) => {
  const { t } = useTranslation();
  const { title, description, onClose, open, ...rest } = props;

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };

  return (
    <Dialog
      {...rest}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="sm"
      aria-labelledby="confirmation-dialog-title"
      open={open}
    >
      <DialogTitle id="confirmation-dialog-title">
        {t(title)}
      </DialogTitle>
      <DialogContent dividers>
        {t(description)}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleOk}
          variant="contained"
          color="secondary"
        >
          {t('OK')}
        </Button>
        <Button
          onClick={handleCancel}
          variant="contained"
          color="primary"
        >
          {t('Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
